<template>
  <div class="ma-3">
    <form>
      <h1 class="title font-weight-regular">
        VSTUPNÉ HODNOTENIE PRED ABSOLVOVANÍM ŠRaVVP - Rizikové skupiny zo
        segregovaných komunít - {{ form.prisoner_full.string_details }}
      </h1>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Domáce násilie &nbsp;
              <v-icon
                @click="showDialog('domace_nasilie')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.domace_nasilie"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený vôbec nedokáže identifikovať prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený takmer vôbec nedokáže identifikovať prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený dokáže identifikovať niektoré prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený dokáže dostatočne identifikovať viaceré prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený dokáže  spoľahlivo identifikovať prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Závislosti látkové &nbsp;
              <v-icon
                @click="showDialog('zavislosti_latkove')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.zavislosti_latkove"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Závislosti nelátkové – patologické hráčstvo &nbsp;
              <v-icon
                @click="showDialog('zavislosti_nelatkove')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.zavislosti_nelatkove"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva, ani o dôsledkoch tohto typu závislosti."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a dôsledkoch tohto typu závislosti."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a o dôsledkoch tohto typu závislosti."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a o dôsledkoch tohto typu závislosti."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky  o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a o dôsledkoch tohto typu závislosti."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Prostitúcia &nbsp;
              <v-icon
                @click="showDialog('prostitucia')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.prostitucia"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o príčinách a rizikách prostitúcie."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky  o príčinách, a rizikách prostitúcie."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky  o príčinách, a rizikách prostitúcie."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatky  o príčinách, a rizikách prostitúcie."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky o príčinách, a rizikách prostitúcie."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Obchodovanie s ľuďmi &nbsp;
              <v-icon
                @click="showDialog('obchodovanie_s_ludmi')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.obchodovanie_s_ludmi"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky  o  obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky  o  obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatky  o  obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky o obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Sekty &nbsp;
              <v-icon
                @click="showDialog('sekty')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.sekty"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Úžera &nbsp;
              <v-icon
                @click="showDialog('uzera')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.uzera"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatkyo úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Extrémizmus, diskriminácia, rasizmus &nbsp;
              <v-icon
                @click="showDialog('extremizmus_diskriminacia_rasizmus')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.extremizmus_diskriminacia_rasizmus"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi obmedzené poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený má čiastočné základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený má dostatočné základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený má plnohodnotné základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Uvedomenie si potreby svojho vzdelania, informovanosť a motivácia
              &nbsp;
              <v-icon
                @click="showDialog('uvedomenie_si_potreby_vzdelania')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.uvedomenie_si_potreby_vzdelania"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="U odsúdeného úplne absentuje motivácia k zvyšovaniu svojho vzdelania/kvalifikácie."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="U odsúdeného je motivácia zvýšiť svoje vzdelanie/kvalifikáciu na nízkej úrovni."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený vykazuje strednú úroveň motivácie zvýšiť svoje vzdelanie/kvalifikáciu."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený vykazuje vyššiu úroveň motivácie zvýšiť svoje vzdelanie/kvalifikáciu."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený vykazuje vysokú motiváciu zvýšiť svoje vzdelanie/kvalifikáciu."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Aktívne hľadanie zamestnania – motivácia a informovanosť &nbsp;
              <v-icon
                @click="showDialog('aktivne_hladanie_zamestnania')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.aktivne_hladanie_zamestnania"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="U odsúdeného úplne absentuje motivácia k aktívnemu hľadaniu zamestnania."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="U odsúdeného je nízka motivácia  k aktívnemu hľadaniu zamestnania."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený vykazuje strednú úroveň motivácie  k aktívnemu hľadaniu zamestnania."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený vykazuje vyššiu úroveň motivácie  k aktívnemu hľadaniu zamestnania."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený vykazuje vysokú motiváciu  k aktívnemu hľadaniu zamestnania."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Bývanie – vysporiadanie pozemkov &nbsp;
              <v-icon
                @click="showDialog('byvanie_vysporiadanie_pozemkov')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.byvanie_vysporiadanie_pozemkov"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nemá žiadne informácie o možnostiach ako zlepšiť svoje bývanie."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený má veľmi málo informácií o možnostiach zlepšenia svojho bývania."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený je čiastočne zorientovaný v možnostiach zlepšenia svojho bývania."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený vie o možnostiach zlepšenia svojho bývania."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený pozná možnosti zlepšenia svojho bývania a plne si uvedomuje, že vysporiadanie vlastníckych a užívacích práv k pozemkom..."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Zdravie &nbsp;
              <v-icon
                @click="showDialog('zdravie')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.zdravie"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený si vôbec neuvedomuje svoju zodpovednosť za svoje zdravie a nemá potrebné informácie  týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený si dostatočne neuvedomuje svoju zodpovednosť za svoje zdravie, jeho informácie  týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie sú veľmi obmedzené."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený si čiastočne uvedomuje svoju zodpovednosť za svoje zdravie a má obmedzené informácie týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený si pripúšťa svoju zodpovednosť za svoje zdravie, no má neúplné informácie týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený si úplne uvedomuje svoju zodpovednosť za svoje zdravie a ovláda všetky zásady zdravého životného štýlu a starostlivosti o zdravie."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Motivácia k zmene životného štýlu &nbsp;
              <v-icon
                @click="showDialog('motivacia_k_zmene_zivotneho_stylu')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="form.absolvovany_pocet_hodin"
                required
                outlined
                label="Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
              />

              <v-radio-group
                v-model="form.motivacia_k_zmene_zivotneho_stylu"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Odsúdený nie je absolútne motivovaný k zmene svojho životného štýlu."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Odsúdený nie je dostatočne motivovaný k zmene svojho životného štýlu."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Odsúdený si je vedomý existencie problémov vedúcich k zníženej kvalite života jeho aj jeho rodiny, je čiastočne motivovaný k zmene svojho životného štýlu."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Odsúdený je motivovaný k celkovej zmene životného štýlu."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Odsúdený je vysoko motivovaný k celkovej zmene životného štýlu."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-card-title />
            <v-card-text>
              <v-file-input
                v-model="dotaznik_file"
                accept=".pdf"
                label="Dotazník CMRS"
              />
              <pdf
                v-if="form.dotaznik"
                style="width: 30%"
                :src="form.dotaznik"
              />
              <v-btn
                v-if="form.dotaznik"
                color="primary"
                @click="downloadItem(form.dotaznik, 'dotaznik')"
              >
                Stiahnuť
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="error"
          @click="closeItem()"
        >
          Uzatvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-text
            v-for="(item, index) in dialog_item.texty"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import pdf from "vue-pdf";
import axios from "axios";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    pdf,
  },

  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      texty: [],
    },

    dotaznik_file: null,

    form: {
      id: null,
      motivacia_odsudeneho_k_pobytu: "",
      hodnotenie_postoja_odsudeneho: "",
      realistickost_hodnotenia_vlastnej_rodinnej: "",
      realistickost_hodnotenia_osobnej_situacie: "",
      motivacia_odsudeneho_k_zivotu_bez_recidivy: "",
      plan_zivota_po_prepusteni: "",
      hodnotenie_urovne_socialnej_komunikacie: "",
      prisoner_full: {
        string_details: "",
      },
    },

    dialogs: {
      domace_nasilie: {
        nazov: "Domáce násilie",
        texts: [
          "Odsúdený vôbec nedokáže identifikovať prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé. Plne akceptuje mýty o násilí, rodové stereotypy a uplatňovanie moci v blízkych vzťahoch. Násilné správanie k blízkym osobám považuje za bežnú realitu týkajúcu sa jeho komunity aj jeho blízkej rodiny.",
          "Odsúdený takmer vôbec nedokáže identifikovať prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé. V jeho chápaní blízkych vzťahov prevládajú mýty o násilí, rodové stereotypy a uplatňovanie moci nad blízkou osobou. Násilné správanie k blízkym osobám považuje za bežnú realitu týkajúcu sa jeho komunity, jeho existenciu vo vlastnej rodine pripúšťa v „ľahšej“ forme.",
          "Odsúdený dokáže identifikovať niektoré prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé. Jeho náhľad na násilie v blízkych vzťahoch však nie je dostačujúci a v jeho myslení a chápaní blízkych vzťahov stále prevládajú mýty o domácom násilí a rodové stereotypy. Uplatňovanie moci nad blízkou osobou za násilie nepovažuje, nie je vnímavý/kritický k nefyzickým formám násilia. S násilným správaním k blízkym osobám sa bežne stretáva v komunite, jeho existenciu vo vlastnej rodine si nepripúšťa.",
          "Odsúdený dokáže dostatočne identifikovať viaceré prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé. Stále však v značnej miere akceptuje mýty o domácom násilí a rodové stereotypy. Uplatňovanie moci nad blízkou osobou síce navonok/účelovo neschvaľuje, no v správaní, postojoch a hodnotovej orientácii je badateľná akceptácia takéhoto správania. S násilným správaním sa stretáva v komunite, o svojej rodine a o sebe je presvedčený, že sa ho netýka.",
          "Odsúdený dokáže  spoľahlivo identifikovať prejavy domáceho násilia a postoje, ktoré pre domáce násilie vytvárajú prostredie ako škodlivé. Neakceptuje mýty o domácom násilí, rodové stereotypy, ani uplatňovanie moci v blízkych vzťahoch. Uvedomuje si závažnosť a neakceptovateľnosť nefyzických foriem násilia. Všetky formy násilia v blízkych vzťahoch odsudzuje, komunite, ktorá ich schvaľuje a realizuje sa snaží vyhýbať a v jeho rodine je toto správanie neprípustné.",
        ],
      },

      zavislosti_latkove: {
        nazov: "Závislosti látkové",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí. Problematické užívanie alkoholu a iných návykových látok považuje za normu, ktorá je bežnou súčasťou jeho života alebo života komunity. Užívanie týchto látok považuje za pozitívum, za spestrenie života alebo zlepšenie nálady. Nie sú mu známe riziká akútnej intoxikácie ani dôsledky látkovej závislosti.",
          "Odsúdený má veľmi obmedzené poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí. Problematické užívanie alkoholu a iných návykových látok nepovažuje za nebezpečné a nevadí mu častý výskyt tohto javu v rodine alebo v komunite. Časté užívanie týchto látok neodsudzuje, sám sa „občas“ pridá. Riziká akútnej intoxikácie a dôsledky látkovej závislosti zbežne pozná, avšak dôrazne neguje.",
          "Odsúdený má čiastočné základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí. Problematické užívanie alkoholu a iných návykových látok  síce nepovažuje za pozitívum, nevidí však nič zlé na ich užívaní vtedy, keď má pocit, že je „pod kontrolou“.  Riziká akútnej intoxikácie a dôsledky látkovej závislosti zbežne pozná, avšak nepripúšťa si, že by sa mohli týkať jeho alebo niekoho z jeho okolia, kto návykové látky užíva.",
          "Odsúdený má dostatočné základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí. Vie, že užívanie alkoholu a iných návykových látok, ako aj hranie na automatoch je považované za rizikové správanie, stále si však úplne naplno neuvedomuje alebo nepripúšťa ich zdravotné, sociálne, ekonomické a iné riziká. Snaží sa vyhýbať nadmernej konzumácii alkoholu a užívaniu iných návykových látok, no pod tlakom okolia má sklony riziko bagatelizovať.",
          "Odsúdený má plnohodnotné základné poznatky o rizikách užívania návykových látok a o rizikách a dôsledkoch vzniku látkových závislostí. Užívanie alkoholu a iných návykových látok považuje za rizikové správanie plne si uvedomujúc jeho zdravotné, sociálne, ekonomické a iné riziká. Alkohol vo zvýšenej miere nekonzumuje, iným návykovým látkam sa úplne vyhýba.",
        ],
      },

      zavislosti_nelatkove: {
        nazov: "Závislosti nelátkové – patologické hráčstvo",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva, ani o dôsledkoch tohto typu závislosti. Hranie na automatoch považuje za bežné trávenie voľného času. Nie sú mu známe a nepripúšťa dôsledky patologického hráčstva, hranie na automatoch považuje za bezpečnú aktivitu.",
          "Odsúdený má veľmi obmedzené poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a dôsledkoch tohto typu závislosti. Riziká akútnej intoxikácie a dôsledky látkovej závislosti zbežne pozná, avšak dôrazne neguje. Hranie na automatoch nepovažuje za škodlivé ani vtedy, keď je pravidelné. Nedokáže si predstaviť, že by mohlo častejšie hranie automatov prerásť do patologického hráčstva.",
          "Odsúdený má čiastočné základné poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a o dôsledkoch tohto typu závislosti. Hranie na automatoch považuje za možnosť, ako si pri troche šťastia zlepšiť príjem, alebo zažiť vzrušenie. Za jediné riziko spojené s hraním automatov považuje jednorazové prehratie vyššej sumy. Neuvedomuje so, že by sa ho mohli niekedy týkať dôsledky hráčskej závislosti.",
          "Odsúdený má dostatočné základné poznatky o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a o dôsledkoch tohto typu závislosti. Vie, že hranie na automatoch je považované za rizikové správanie, stále si však úplne naplno neuvedomuje alebo nepripúšťa ich sociálne, ekonomické a iné riziká. Snaží sa vyhýbať hraniu na automatoch, no pod tlakom okolia má sklony riziko bagatelizovať.",
          "Odsúdený má plnohodnotné základné poznatky  o rizikách, rizikovom správaní, ktoré vedie k vzniku patologického hráčstva a o dôsledkoch tohto typu závislosti. Hranie na automatoch považuje za rizikové správanie plne si uvedomujúc jeho sociálne, ekonomické a iné riziká. Hraniu na automatoch sa úplne vyhýba.",
        ],
      },

      prostitucia: {
        nazov: "Prostitúcia",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o príčinách a rizikách prostitúcie. Prostitúciu vôbec nepovažuje za negatívny jav, ale za prirodzenú súčasť života. Nemá absolútne žiadnu predstavu o tom, že prostitúcia so sebou nesie aj široké spektrum sociálno-patologických javov a je previazaná na rôzne závažné formy kriminality, ako drogová kriminalita, obchodovanie s ľuďmi či sexuálne zneužívanie detí. Zdravotné riziká vykonávania prostitúcie a využívania týchto služieb mu nie sú vôbec známe.",
          "Odsúdený má veľmi obmedzené poznatky  o príčinách, a rizikách prostitúcie. Prostitúciu považuje za bežný jav, nad ktorého negatívami sa nezamýšľa. Pripúšťa, že vykonávanie prostitúcie môže byť spojené s prostredím, ktoré vykazuje určité prejavy sociálnej patológie, nepripúšťa si však, že by s ňou mohli byť spojené rôzne závažné formy kriminality. Zdravotné riziká prostitúcie nerieši.",
          "Odsúdený má čiastočné základné poznatky  o príčinách, a rizikách prostitúcie. Vie, že prostitúcia je spojená so zdravotnými rizikami, je však presvedčený, že sa takýmto rizikám dá spoľahlivo vyhnúť. Prostitúciu nepovažuje za vyslovene negatívny jav. Nechápe, že sú s ňou spojené rôzne závažné formy kriminality, ako drogová kriminalita, obchodovanie s ľuďmi či sexuálne zneužívanie detí. Prostitúciu nepovažuje za nebezpečnú, hoci vie, že sa vyskytuje v prostredí prejavujúcom viaceré znaky sociálnej patológie.",
          "Odsúdený má dostatočné základné poznatky  o príčinách, a rizikách prostitúcie. Uvedomuje si negatíva a riziká spojené s prostitúciou, nie však natoľko, aby ju považoval za vyslovene nebezpečný a negatívny jav. Vie o jej zdravotných rizikách a má vedomosti o jej spojení so závažnými druhmi kriminality, ako drogová kriminalita, obchodovanie s ľuďmi či sexuálne zneužívanie detí. Nie sú však pre neho natoľko reálne, aby si pripustil ich previazanie s prostitúciou za každých okolností.",
          "Odsúdený má plnohodnotné základné poznatky o príčinách, a rizikách prostitúcie. Prostitúciu považuje odsúdený jednoznačne za negatívny a nebezpečný jav. Plne si uvedomuje zdravotné riziká spojené s poskytovaním a využívaním služieb prostitúcie. Vie, že s prostitúciou sú spojené rôzne druhy závažnej kriminality, ako drogová kriminalita, obchodovanie s ľuďmi a sexuálne zneužívanie detí.",
        ],
      },

      obchodovanie_s_ludmi: {
        nazov: "Obchodovanie s ľuďmi",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality. Nemá žiadne informácie o obchodovaní s ľuďmi, ktoré by mu pomohli vyhnúť sa tomuto typu kriminality. Nedokáže identifikovať znaky podozrivej pracovnej ponuky v zahraničí, ktorá môže v prípade vycestovania za prácou viesť k tomu, že by sa dotyčný stal obeťou obchodovania s ľuďmi. Nemá poznatky o existencii rizika vykorisťovania pod hrozbou násilia, donucovaním alebo zneužitím zraniteľného postavenia obetí.",
          "Odsúdený má veľmi obmedzené poznatky  o  obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality. O existencii obchodovania s ľuďmi už počul, no stále sa mu tento problém javí ako príliš vzdialený a abstraktný, aby sa snažil vyhnúť tomuto typu kriminality. Má určité, veľmi slabé  poznatky o existencii  rizika vykorisťovania pod hrozbou násilia, donucovaním alebo zneužitím zraniteľného postavenia obetí, nedokáže však toto riziko sám identifikovať a aktívne sa mu brániť. Nedokáže identifikovať podozrivé pracovné ponuky, ktoré sú z hľadiska možného obchodovania s ľuďmi rizikové.",
          "Odsúdený má čiastočné základné poznatky  o  obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality. Vie o existencii obchodovania s ľuďmi, no nemá o ňom toľko potrebných informácií, aby sa s istotou dokázal vyhnúť tomuto typu kriminality. Má určité poznatky o existencii  rizika vykorisťovania pod hrozbou násilia, donucovaním alebo zneužitím zraniteľného postavenia obetí, nedokáže však toto riziko sám identifikovať a aktívne sa mu brániť. Nedokáže dostatočne spoľahlivo identifikovať podozrivé pracovné ponuky, ktoré sú z hľadiska možného obchodovania s ľuďmi rizikové.",
          "Odsúdený má dostatočné základné poznatky  o  obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality. Má dostatok informácií o obchodovaní s ľuďmi, ktoré by mu mohli pomôcť vyhnúť sa tomuto typu kriminality. Má poznatky o existencii rizika vykorisťovania pod hrozbou násilia, donucovaním alebo zneužitím zraniteľného postavenia obetí. S nie veľkou istotou identifikuje znaky podozrivej pracovnej ponuky v zahraničí, ktorá môže v prípade vycestovania za prácou viesť k tomu, že by sa dotyčný stal obeťou obchodovania s ľuďmi, nie je však istota, že by raz na podobnú ponuku nereflektoval.",
          "Odsúdený má plnohodnotné základné poznatky o obchodovaní s ľuďmi a o rizikovom správaní, ktoré zvyšuje riziko viktimácie týmto typom kriminality. Má všetky potrebné informácie o obchodovaní s ľuďmi, ktoré mu môžu pomôcť vyhnúť sa tomuto typu kriminality.  Má poznatky o existencii rizika vykorisťovania pod hrozbou násilia, donucovaním alebo zneužitím zraniteľného postavenia obetí. Dokáže spoľahlivo identifikovať znaky podozrivej pracovnej ponuky v zahraničí, ktorá môže v prípade vycestovania za prácou viesť k tomu, že by sa dotyčný stal obeťou obchodovania s ľuďmi.",
        ],
      },

      sekty: {
        nazov: "Sekty",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo. Nemá žiadny náhľad na existenciu manipulatívneho správania predstaviteľov siekt, nerozozná ich metódy lákania nových členov ani cieľ, s akými tieto praktiky používajú. Slepo dôveruje tomu, že v prípade oslovenia členom takéhoto spoločenstva by išlo o dobré úmysly z jeho strany. Nerozozná manipulatívne praktiky týchto spoločenstiev uplatňované k ich členom, preto je veľmi vysoké riziko, že im sám môže byť vystavený. Nepozná rozdiel medzi registrovanou cirkvou a náboženskou sektou.",
          "Odsúdený má veľmi obmedzené poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo. O náboženských sektách už určité informácie počul, no nedokáže si predstaviť, že by sa nebezpečenstvo mohlo týkať aj jeho alebo jeho rodiny či komunity. Jeho informácie o sektách sú veľmi slabé, preto mu stále nie je jasný rozdiel medzi náboženskou sektou a registrovanou cirkvou.  Nerozozná manipulatívne praktiky týchto spoločenstiev uplatňované k ich členom. Z toho plynie vysoké nebezpečenstvo možnej manipulácie odsúdeného zo strany predstaviteľov siekt.",
          "Odsúdený má čiastočné základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo. O existencii náboženských siekt má určité elementárne poznatky, no nemá ich dostatok na to, aby dokázal bezpečne rozoznať náboženskú sektu a registrovanú cirkev.  Nerozozná dostatočne manipulatívne praktiky týchto spoločenstiev uplatňované k ich členom. Z toho plynie nebezpečenstvo možnej manipulácie odsúdeného zo strany predstaviteľov siekt, najmä v životných etapách, kedy má zvýšenú potrebu podpory a spolupatričnosti.",
          "Odsúdený má dostatočné základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo. Odsúdený má pomerne dobré znalosti o manipulatívnom správaní predstaviteľov siekt. Pozná ciele, s akými sa sekty snažia získavať nových členov aj manipulatívne praktiky uplatňované k členom takýchto spoločenstiev. Rozdiel medzi registrovanou cirkvou a náboženskou sektou dokáže rozoznať, no nie je u neho istota, že by takému správaniu v ťažkej životnej situácii nepodľahol. Pravdepodobnosť je však nízka.",
          "Odsúdený má plnohodnotné základné poznatky o sektách a ich nebezpečenstve pre jedinca, jeho rodinu a širšie spoločenstvo. Veľmi dobre rozozná manipulatívne správanie predstaviteľov siekt a ich metódy lákania nových členov. Cieľ, s akým sa sekty snažia nových členov získať mu je dobre známy. V prípade oslovenia členom takéhoto spoločenstva by osobu dokázal identifikovať ako nevierohodnú. Spoľahlivo odlíši nebezpečnú náboženskú sektu od registrovanej cirkvi.",
        ],
      },

      uzera: {
        nazov: "Úžera",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo. „Služby“ úžerníkov považuje za pomoc a jedinú formu riešenia momentálnej zlej finančnej situácie. Neuvedomuje si dôsledky využívania ponuky úžerníkov v neustálom náraste dlhov, ktoré nebude nikdy schopný splatiť. Nepozná akceptovateľné formy riešenia dlhodobej alebo situačnej chudoby, ani zákonné možnosti zbavenia dlhov, alebo mu tieto možnosti nie sú dostupné.",
          "Odsúdený má veľmi obmedzené poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo. Tuší, že „služby“ úžerníkov nie sú až taká pomoc, ako by sa mohlo zdať, no dôsledky ich využívania si nedokáže spočítať. Nemá takmer žiadne informácie o legálnych formách riešenia dlhodobej alebo situačnej chudoby či o zákonných možnostiach zbavenia dlhov, alebo má k týmto možnostiam veľmi sťaženú dostupnosť.",
          "Odsúdený má čiastočné základné poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo. „Služby“ úžerníkov síce považuje za veľmi drahé a využíva ich nerád, ale stále je to pre neho jediná prijateľná forma riešenia v prípade akútnej finančnej núdze. Konštantné narastanie dlhov pri využívaní služieb úžerníkov radšej nepočíta. Jeho informácie o legálnych riešeniach dlhodobej alebo situačnej chudoby či oddlženia sú obmedzené, rovnako ako ich dostupnosť pre odsúdeného.",
          "Odsúdený má dostatočné základné poznatkyo úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo. Odsúdený si uvedomuje predraženosť a dôsledky využívania „služieb“ úžerníkov, no ani to mu nezabráni príležitostne ich využiť. Má informácie o legálnych riešeniach dlhodobej alebo situačnej chudoby a oddlženia, avšak nie na takej úrovni, aby ich plánoval niekedy využiť.",
          "Odsúdený má plnohodnotné základné poznatky o úžere a jej negatívnych dopadoch pre jedinca, jeho rodinu a širšie spoločenstvo. Odsúdený si plne uvedomuje predraženosť a dôsledky využívania „služieb“ úžerníkov. Chápe, že i len jednorazové využitie takejto ponuky by mohlo jeho a jeho rodinu uvrhnúť do kolobehu  narastajúcich dlhov a zvyšujúcich sa splátok, z akého by nebolo cesty von. „Služby“ úžerníkov nevyužíva. Pre prípad potreby má dostačujúce informácie o legálnych riešeniach dlhodobej alebo situačnej chudoby a oddlženia.",
        ],
      },

      extremizmus_diskriminacia_rasizmus: {
        nazov: "Extrémizmus, diskriminácia, rasizmus",
        texts: [
          "Odsúdený nemá žiadne základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom. Nemá základné znalosti o rasizme a rasovej neznášanlivosti a ich nebezpečenstve pre minoritnú aj majoritnú spoločnosť. Nie je mu známe uplatňovanie zásady rovnakého zaobchádzania ani prostriedky právnej ochrany v prípade jej porušenia.",
          "Odsúdený má veľmi obmedzené poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom. Má iba základné, veľmi slabé znalosti o rasizme a rasovej neznášanlivosti a ich nebezpečenstve pre minoritnú aj majoritnú spoločnosť. Myslí si, že by mala platiť zásada rovnakého zaobchádzania, no nevie nič o jej uplatňovaní ani o tom, že existujú prostriedky právnej ochrany v prípade jej porušenia.",
          "Odsúdený má čiastočné základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom. Má určité elementárne znalosti o rasizme a rasovej neznášanlivosti, no nie dostatočné na to, aby dokázal identifikovať nebezpečenstvo rasovej neznášanlivosti pre minoritnú aj majoritnú spoločnosť. Vie o  zásade rovnakého zaobchádzania, no nepozná dobre spôsob jej uplatňovania.  Prostriedky právnej ochrany v prípade jej porušenia mu nie sú známe.",
          "Odsúdený má dostatočné základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom. Má základné znalosti o rasizme a rasovej neznášanlivosti a ich nebezpečenstve pre minoritnú aj majoritnú spoločnosť. Pozná uplatňovanie zásady rovnakého zaobchádzania, aj prostriedky právnej ochrany v prípade jej porušenia, no nedokázal by ich využiť.",
          "Odsúdený má plnohodnotné základné poznatky o prevencii pred diskrimináciou, extrémizmom a rasizmom. Má potrebné základné znalosti o rasizme a rasovej neznášanlivosti a ich nebezpečenstve pre minoritnú aj majoritnú spoločnosť. Veľmi dobre pozná uplatňovanie zásady rovnakého zaobchádzania, aj prostriedky právnej ochrany v prípade jej porušenia a dokázal by ich využiť.",
        ],
      },

      uvedomenie_si_potreby_vzdelania: {
        nazov:
          "Uvedomenie si potreby svojho vzdelania, informovanosť a motivácia",
        texts: [
          "U odsúdeného úplne absentuje motivácia k zvyšovaniu svojho vzdelania/kvalifikácie. Nemyslí si, že by tým zvýšil svoju hodnotu na trhu práce a zlepšil šance na lepšiu kvalitu života pre seba aj pre rodinu. Myslí si, že jeho vzdelanie je postačujúce, aj napriek tomu, že to tak nie je, o vzdelanie nemá záujem napriek tomu, že ho potrebuje. Nemá žiadne informácie o možnostiach zvýšenia vzdelania/kvalifikácie. Nemá vôbec záujem tieto informácie získať.",
          "U odsúdeného je motivácia zvýšiť svoje vzdelanie/kvalifikáciu na nízkej úrovni. Čiastočne si uvedomuje, že by tým zvýšil svoju hodnotu na trhu práce a zlepšil šance na lepšiu kvalitu života pre seba aj rodinu, no zvýšenie kvalifikácie nepovažuje za dostatočne dôležité a neverí, že by pre jeho život znamenalo takú významnú zmenu, aby nad ním uvažoval. Má obmedzené informácie o možnostiach zvýšenia vzdelania/kvalifikácie, v ktorých sa orientuje len veľmi ťažko a ich využitie v praxi nie je veľmi pravdepodobné.",
          "Odsúdený vykazuje strednú úroveň motivácie zvýšiť svoje vzdelanie/kvalifikáciu.  Uvedomuje si, že by tým zvýšil svoju hodnotu na trhu práce a zlepšil šance na lepšiu kvalitu života pre seba aj pre rodinu, no vzdialená predstava možnej zmeny nie je dosť silná na to, aby sa dokázal mobilizovať. Má neúplné informácie o možnostiach zvýšenia vzdelania/kvalifikácie a ich využitie po prepustení je veľmi otázne.",
          "Odsúdený vykazuje vyššiu úroveň motivácie zvýšiť svoje vzdelanie/kvalifikáciu. Uvedomuje si, že nadobudnutie vyššieho vzdelania/kvalifikácie pomôže zvýšiť hodnotu človeka na trhu práce a tým aj kvalitu života  jeho a jeho rodiny,  no nie je úplne presvedčený o tom, že by takéto zlepšenie/úspech dosiahol aj on. Má dostatočné informácie ako a kde získať vzdelanie alebo zvýšiť svoju kvalifikáciu a je pravdepodobné, že ich po prepustení využije.",
          "Odsúdený vykazuje vysokú motiváciu zvýšiť svoje vzdelanie/kvalifikáciu. Plne si uvedomuje, že nadobudnutím vyššieho vzdelania alebo kvalifikácie zvýši svoju hodnotu na trhu práce a tým zvýši šance seba a svojej rodiny na lepšiu budúcnosť. Disponuje všetkými potrebnými informáciami o tom, kde a ako získať vzdelanie alebo zvýšiť svoju kvalifikáciu a je pripravený a odhodlaný ich využiť.",
        ],
      },

      aktivne_hladanie_zamestnania: {
        nazov: "Aktívne hľadanie zamestnania – motivácia a informovanosť",
        texts: [
          "U odsúdeného úplne absentuje motivácia k aktívnemu hľadaniu zamestnania. Nemá žiadne informácie o potrebných náležitostiach uchádzania sa o zamestnanie. Nemá vôbec záujem tieto informácie získať. Vzhľadom na nezáujem a absenciu motivácie k hľadaniu zamestnania nie je prognóza pri hľadaní zamestnania ani pod dohľadom odborníka priaznivá.",
          "U odsúdeného je nízka motivácia  k aktívnemu hľadaniu zamestnania. Má veľmi málo informácií o potrebných náležitostiach uchádzania sa o zamestnanie, v ktorých sa orientuje len veľmi ťažko a ich využitie v praxi nie je veľmi pravdepodobné. Po prepustení bude potrebovať dohľad odborníka, aby ďalej pracoval na zvýšení svojej šance pri hľadaní zamestnania.",
          "Odsúdený vykazuje strednú úroveň motivácie  k aktívnemu hľadaniu zamestnania. Má neúplné informácie o  potrebných náležitostiach uchádzania sa o zamestnanie a ak nebude intenzívnejšie spolupracovať s odborníkom pri hľadaní zamestnania, ich využitie po prepustení je veľmi otázne.",
          "Odsúdený vykazuje vyššiu úroveň motivácie  k aktívnemu hľadaniu zamestnania. Má dostatočné informácie  o  potrebných náležitostiach uchádzania sa o zamestnanie a je pravdepodobné, že ich po prepustení využije. Vzhľadom na jeho úroveň motivácie a znalostí má v prípade usmernenia odborníkom dobrú šancu na úspech pri hľadaní zamestnania.",
          "Odsúdený vykazuje vysokú motiváciu  k aktívnemu hľadaniu zamestnania. Disponuje všetkými potrebnými informáciami o potrebných náležitostiach uchádzania sa o zamestnanie a je pripravený a odhodlaný ich využiť. Je pripravený a schopný uchádzať sa o zamestnanie bez pomoci odborníka.",
        ],
      },

      byvanie_vysporiadanie_pozemkov: {
        nazov: "Bývanie – vysporiadanie pozemkov",
        texts: [
          "Odsúdený nemá žiadne informácie o možnostiach ako zlepšiť svoje bývanie. Vôbec nepozná legalizačný proces vysporiadania vlastníckych a užívacích práv k pozemkom pod osídleniami v segregovaných sídlach, ktorý je predpokladom vybudovania infraštruktúry a tým aj zlepšenia kvality života.",
          "Odsúdený má veľmi málo informácií o možnostiach zlepšenia svojho bývania. Uvedomuje si, že možnosť vysporiadania vlastníckych a užívacích práv k pozemkom pod osídleniami v segregovaných sídlach, by mu pomohla zlepšiť kvalitu života, no nemá o tejto možnosti informácie.",
          "Odsúdený je čiastočne zorientovaný v možnostiach zlepšenia svojho bývania. Má informácie, že existuje možnosť vysporiadania pozemkov pod osídleniami v segregovaných sídlach, no  nevie, ako tento proces prebieha a kam sa v prípade záujmu obrátiť.",
          "Odsúdený vie o možnostiach zlepšenia svojho bývania. Uvedomuje si, že možnosť vysporiadania vlastníckych a užívacích práv k pozemkom pod osídleniami by zvýšilo kvalitu života jeho aj jeho rodiny. Pozná legalizačný proces vysporiadania pozemkov, no nie je pre neho dostatočne zrozumiteľný a nevie ho sám využiť.",
          "Odsúdený pozná možnosti zlepšenia svojho bývania a plne si uvedomuje, že vysporiadanie vlastníckych a užívacích práv k pozemkom pod osídleniami je cestou k vybudovaniu potrebnej infraštruktúry a zvýšeniu kvality života obyvateľov., Chápe a ovláda nastavený legalizačný proces vysporiadania pozemkov a je pripravený sa do neho zapojiť.",
        ],
      },

      zdravie: {
        nazov: "Zdravie",
        texts: [
          "Odsúdený si vôbec neuvedomuje svoju zodpovednosť za svoje zdravie a nemá potrebné informácie  týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie.",
          "Odsúdený si dostatočne neuvedomuje svoju zodpovednosť za svoje zdravie, jeho informácie  týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie sú veľmi obmedzené.",
          "Odsúdený si čiastočne uvedomuje svoju zodpovednosť za svoje zdravie a má obmedzené informácie týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie.",
          "Odsúdený si pripúšťa svoju zodpovednosť za svoje zdravie, no má neúplné informácie týkajúce sa zásad zdravého životného štýlu a starostlivosti o zdravie.",
          "Odsúdený si úplne uvedomuje svoju zodpovednosť za svoje zdravie a ovláda všetky zásady zdravého životného štýlu a starostlivosti o zdravie.",
        ],
      },

      motivacia_k_zmene_zivotneho_stylu: {
        nazov: "Motivácia k zmene životného štýlu",
        texts: [
          "Odsúdený nie je absolútne motivovaný k zmene svojho životného štýlu, necíti potrebu zmeny, neakceptuje potrebu vzdelávania sa v oblastiach relevantných pre zlepšenie kvality života jeho aj jeho rodiny. Nemá záujem meniť svoje doterajšie zaužívané zvyky a spôsoby správania. Absentuje sebareflexia, uvedomenie si vlastných chýb a miery pričinenia k existujúcim problémom. Nie je schopný odolať vplyvu komunity v ani prípade, že by ho tento vplyv vtiahol späť do problémov, alebo bránil zlepšeniu kvality života. Príčiny problémov externalizuje  („Štát sa o mňa nepostaral...., Nemal som kde bývať..., Nemal som prácu..., Kamaráti ma ťahali dole...“). Akúkoľvek odbornú pomoc odmieta.",
          "Odsúdený nie je dostatočne motivovaný k zmene svojho životného štýlu, aj napriek tomu, že čiastočne pripúšťa potrebu zmeny. Sebareflexia v súvislosti s jeho životným štýlom či problémami je nízka, čiastočne si uvedomuje existenciu problémov a potrebu zmeny, avšak stále ich zľahčuje a externalizuje. Nie je dostatočne motivovaný k vzdelávaniu sa a k zmene v oblastiach relevantných pre zlepšenie kvality života jeho aj jeho rodiny. Je presvedčený, že odbornú pomoc nepotrebuje. Veľmi ťažko odoláva vplyvu komunity aj v prípade, že by ho tento vplyv vtiahol späť do problémov, alebo bránil zlepšeniu kvality života.",
          "Odsúdený si je vedomý existencie problémov vedúcich k zníženej kvalite života jeho aj jeho rodiny, je čiastočne motivovaný k zmene svojho životného štýlu. Nedokáže však urobiť dostatočné zmeny svojho životného štýlu bez pomoci svojho okolia a odborníkov. Je v stave, kedy zvažuje výhody vs. nevýhody tejto zmeny. Je potrebná pomoc odborníkov na udržanie jeho motivácie k zmene. Vzdelávanie v tejto oblasti neodmieta,  súvisiacim zmenám však nie je dostatočne prístupný.",
          "Odsúdený je motivovaný k celkovej zmene životného štýlu. Prítomnosť problémov, ktoré vedú k zníženiu kvality života pripúšťa, má motiváciu zmeniť svoj životný štýl, avšak nie je schopný samostatne bez pomoci odborníkov túto zmenu vykonať. Vzdelávať sa  v oblastiach relevantných pre zlepšenie kvality života chce, s potrebou práce na sebe je aspoň čiastočne vyrovnaný, pomoc odborníkov prijíma a spolupracuje, chce ju využívať aj po VTOS. Svoj podiel na vzniknutej životnej situácii si uvedomuje a pripúšťa.",
          "Odsúdený je vysoko motivovaný k celkovej zmene životného štýlu, uvedomuje si, že bude musieť odolávať aj vplyvu komunity na to, aby dokázal vyriešiť svoje problémy a zlepšiť kvalitu života pre seba aj svoju rodinu. Svoju problémy si pripúšťa, chce sa vzdelávať v oblastiach relevantných pre zlepšenie kvality života. Má záujem spolupracovať s odborníkmi ako počas výkonu trestu, tak aj po prepustení na slobodu. Je motivovaný k zmene a je nastavený zvládnuť aj niektoré straty, ktoré so zmenou súvisia. Zodpovednosť na vzniku problémov a za zmenu kvality života k lepšiemu vidí najmä na svojej strane.",
        ],
      },
    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    showDialog(x) {
      this.dialog = true;
      this.dialog_item.nazov = this.dialogs[x].nazov;
      this.dialog_item.texty = this.dialogs[x].texts;
    },
    getItem() {
      apiService
        .getGeneralSegregovaneKomunityPred(this.$route.params.id)
        .then((response) => {
          this.form = response;
        });
    },

    updateItem() {
      let formData = new FormData();

      for (var key in this.form) {
        if (key == "dotaznik") continue;

        if (this.form[key] != null) formData.set(key, this.form[key]);
      }

      if (this.dotaznik_file == null) formData.append("dotaznik", "");

      if (this.dotaznik_file instanceof File)
        formData.append("dotaznik", this.dotaznik_file);

      apiService
        .updateGeneralSegregovaneKomunityPred(formData, this.$route.params.id)
        .then(
          (response) => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť tento formulár? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;
            this.updateItem();
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },

    downloadItem(url, typeItem) {
      var oldThis = this;
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            oldThis.form.prisoner_full.string_details + "_" + typeItem + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(function () {
          oldThis.snackbar_error = true;
        });
    },
  },
};
</script>